import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../componentes/Plantilla/Plantilla';
import ContactSection from '../../componentes/Secciones/Contacto/SeccionContacto';
import VideoPlayer from '../../componentes/UI/VideoPlayer';

import Breadcrumbs from '../../componentes/UI/Breadcrumbs';
import styles from './ServicioDetalle.module.css';

const BASE = '/imagenes/proyectos';

const useReveal = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
};

const equipos = [
  { nombre: 'Tarjetas Electrónicas y Control', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 9h6v6H9z"/></svg> },
  { nombre: 'Sensores y Válvulas', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28"><path d="M4 14l8-8 8 8"/><path d="M12 14v8"/></svg> },
  { nombre: 'Motores y Transmisiones', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M22 12h-2M4 12H2"/></svg> },
  { nombre: 'Rodamientos y Sellos', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="4"/></svg> },
];

const beneficios = [
  { valor: '↑ Calidad', desc: 'Garantía de fábrica y respaldo directo en cada componente suministrado', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> },
  { valor: '↓ Tiempos', desc: 'Stock permanente para envíos inmediatos a toda la república', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg> },
  { valor: '↓ Riesgos', desc: 'Evite problemas de compatibilidad usando solo repuestos 100% originales', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg> },
];

const pasos = [
  { num: '01', titulo: 'Asesoría experta', sub: 'Identificación de partes', desc: 'Le ayudamos a encontrar el número de parte exacto para su equipo DOMUS.' },
  { num: '02', titulo: 'Cotización rápida', sub: 'Precios competitivos', desc: 'Presupuesto claro y transparente sin costos ocultos.' },
  { num: '03', titulo: 'Preparación', sub: 'Empaque seguro', desc: 'Preparación cuidadosa para proteger la integridad de los componentes.' },
  { num: '04', titulo: 'Distribución', sub: 'Logística eficiente', desc: 'Envíos express y seguros a cualquier parte de la república mexicana.' },
];

const fotos = [
  `${BASE}/lavanderia_lavadora_hpw_10_touch_ii_hw_24.webp`,
  `/imagenes/servicios/lavanderia-img-9.webp`,
  `${BASE}/lavanderia_lavadora_7_26.webp`,
  `/imagenes/servicios/lavanderia-img-10.webp`,
  `${BASE}/lavanderia_lavadora_de_ropa_barrera_sanitaria_18.webp`,
  `/imagenes/servicios/lavanderia-img-11.webp`,
];

const RepuestosDomus = () => {
  const [heroRef, heroVis] = useReveal();
  const [objRef, objVis] = useReveal();
  const [alcRef, alcVis] = useReveal();
  const [procRef, procVis] = useReveal();
  const [vidRef, vidVis] = useReveal();
  const [galRef, galVis] = useReveal();

  const [lightboxSrc, setLightboxSrc] = useState(null);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setLightboxSrc(null); };
    if (lightboxSrc) {
      window.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      window.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [lightboxSrc]);

  return (
    <Layout>

      {/* ── HERO ── */}
      <section
        ref={heroRef}
        className={styles.hero}
        style={{ backgroundImage: `url(/imagenes/proyectos/lavanderia_lavadora_de_ropa_barrera_sanitaria_18.webp)` }}
      >
        <div className={styles.heroOverlay} />
        <div className={`container ${styles.heroContent}`}>
          <Breadcrumbs 
            paths={[
              { label: 'Inicio', to: '/' },
              { label: 'Servicios', to: '/servicios' },
              { label: 'Repuestos DOMUS' }
            ]}
          />
          <h1 className={`${styles.heroTitle} ${heroVis ? styles.titleVis : ''}`}>
            Repuestos<br/><span className={styles.acento}>DOMUS</span>
          </h1>
          <div className={`${styles.heroLine} ${heroVis ? styles.lineVis : ''}`} />
          <p className={`${styles.heroSub} ${heroVis ? styles.subVis : ''}`}>
            Suministro de refacciones y repuestos originales de la línea DOMUS.
          </p>
          <div className={`${styles.heroCtas} ${heroVis ? styles.ctasVis : ''}`}>
            <a href="#contact" className="btn btn-primary">Cotizar refacción</a>
            <Link to="/servicios" className={styles.backLink}>← Todos los servicios</Link>
          </div>
        </div>
      </section>

      {/* ── OBJETIVO + FOTO CAMPO ── */}
      <section ref={objRef} className={styles.objetivoSection}>
        <div className="container">
          <div className={`${styles.objetivoGrid} ${objVis ? styles.gridVis : ''}`}>
            <div className={styles.objetivoTexto}>
              <h2 className={styles.secTitle}>
                Distribuidor<br/>
                <span className={styles.acento}>Autorizado</span>
              </h2>
              <div className={styles.secLine} />
              <p className={styles.objetivoDesc}>
                Somos distribuidores autorizados de la línea DOMUS de repuestos para equipo de lavandería industrial. Mantenemos stock permanente de los componentes más demandados para garantizar entregas rápidas y evitar paros en su producción.
              </p>
              <div className={styles.specsBar}>
                <div className={styles.specItem}>
                  <span className={styles.specValor}>100%</span>
                  <span className={styles.specLabel}>Originales</span>
                </div>
                <div className={styles.specDivider} />
                <div className={styles.specItem}>
                  <span className={styles.specValor}>Express</span>
                  <span className={styles.specLabel}>Envíos</span>
                </div>
              </div>
            </div>
            <div className={styles.objetivoFotoCol}>
              <div className={styles.objetivoFotoWrapSingle}>
                <img src={`/imagenes/proyectos/lavanderia_lavadora_hpw_10_touch_ii_hw_24.webp`} alt="Repuestos Originales DOMUS" className={styles.objetivoFoto} loading="lazy" />
              </div>
              
              <div className={styles.singleImageCaption}>
                <span className={styles.comparadorCaptionLabel}>CALIDAD ORIGINAL DOMUS</span>
                <p className={styles.comparadorCaptionTexto}>Piezas 100% originales que aseguran un ajuste perfecto y extienden la vida útil de sus equipos de lavandería.</p>
              </div>
            </div>
          </div>

          {/* Beneficios en fila debajo del grid */}
          <div className={styles.beneficiosRow}>
            {beneficios.map((b, i) => (
              <div
                key={i}
                className={`${styles.beneficioCard} ${objVis ? styles.cardVis : ''}`}
                style={{ transitionDelay: `${400 + i * 120}ms` }}
              >
                <div className={styles.beneficioIcon}>{b.icon}</div>
                <div>
                  <span className={styles.beneficioValor}>{b.valor}</span>
                  <p className={styles.beneficioDesc}>{b.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ALCANCE ── */}
      <section ref={alcRef} className={styles.alcanceSection}>
        <div className="container">
          <div className={`${styles.alcanceHeader} ${alcVis ? styles.headerVis : ''}`}>
            <h2 className={styles.secTitleDark}>Equipos que <span className={styles.acento}>intervenimos</span></h2>
            <div className={styles.secLine} />
          </div>
          <div className={styles.equiposGrid}>
            {equipos.map((e, i) => (
              <div
                key={i}
                className={`${styles.equipoCard} ${alcVis ? styles.equipoVis : ''}`}
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div className={styles.equipoIcon}>{e.icon}</div>
                <span className={styles.equipoNombre}>{e.nombre}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROCESO ── */}
      <section ref={procRef} className={styles.procesoSection}>
        <div className="container">
          <div className={`${styles.procesoHeader} ${procVis ? styles.headerVis : ''}`}>
            <h2 className={styles.secTitle}>Cómo <span className={styles.acento}>trabajamos</span></h2>
            <div className={styles.secLine} />
          </div>

          {/* Pasos + foto lateral */}
          <div className={styles.procesoLayout}>
            <div className={styles.pasosGrid}>
              {pasos.map((p, i) => (
                <div
                  key={i}
                  className={`${styles.pasoCard} ${procVis ? styles.pasoVis : ''}`}
                  style={{ transitionDelay: `${i * 100}ms` }}
                >
                  <div className={styles.pasoNum}>{p.num}</div>
                  <div className={styles.pasoContenido}>
                    <span className={styles.pasoSub}>{p.sub}</span>
                    <h3 className={styles.pasoTitulo}>{p.titulo}</h3>
                    <p className={styles.pasoDesc}>{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className={`${styles.procesoFotoCol} ${procVis ? styles.procesoFotoVis : ''}`}>
              <div className={styles.procesoFotoWrap}>
                <VideoPlayer 
                  src="/videos/servicios/lavanderia-vid-4.mp4" 
                  wrapperStyle={{ height: '100%' }}
                  videoStyle={{ height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className={`${styles.tiempoNote} ${procVis ? styles.noteVis : ''}`}>
                <div className={styles.noteIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                    <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
                  </svg>
                </div>
                <p><strong>Tiempo de entrega:</strong> varía según la disponibilidad en stock local o la necesidad de importación directa desde el fabricante.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── VIDEO PRINCIPAL ── */}
      <section ref={vidRef} className={styles.videoSection}>
        <div className="container">
          <div className={`${styles.videoHeader} ${vidVis ? styles.headerVis : ''}`} style={{ textAlign: 'center' }}>
            <h2 className={styles.secTitle}>
              <span className={styles.acento}>VIDEOS</span>
            </h2>
            <div className={styles.secLine} />
          </div>
          <div className={styles.videosLayout}>
            {/* Fila superior: dos videos verticales */}
            <div className={`${styles.videoCol2} ${vidVis ? styles.videoGridVis : ''}`}>
              <VideoPlayer src="/videos/servicios/lavanderia-vid-5.mp4" />
              <VideoPlayer src="/videos/servicios/lavanderia-vid-1.mp4" />
            </div>
            {/* Fila inferior: video horizontal */}
            <div className={`${styles.videoCol1} ${vidVis ? styles.videoGridVis : ''}`}>
              <VideoPlayer src="/videos/servicios/lavanderia-vid-2.mp4" />
            </div>
          </div>
        </div>
      </section>

      {/* ── GALERÍA ── */}
      <section ref={galRef} className={styles.galeriaSection}>
        <div className="container">
          <div className={`${styles.galeriaHeader} ${galVis ? styles.headerVis : ''}`} style={{ textAlign: 'center' }}>
            <h2 className={styles.secTitle}>
              <span className={styles.acento}>FOTOS</span>
            </h2>
            <div className={styles.secLine} />
          </div>
          <div className={styles.galeriaGrid}>
            {fotos.map((src, i) => (
              <div
                key={i}
                className={`${styles.fotoWrap} ${galVis ? styles.fotoVis : ''}`}
                style={{ transitionDelay: `${i * 80}ms` }}
                onClick={() => setLightboxSrc(src)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setLightboxSrc(src)}
                aria-label={`Ver foto ${i + 1} en grande`}
              >
                <img src={src} alt={`Limpieza tubería industrial ${i + 1}`} className={styles.foto} loading="lazy" />
                <div className={styles.fotoOverlayHover}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28">
                    <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className={styles.ctaSection}>
        <div className="container">
          <div className={styles.ctaCard}>
            <div className={styles.ctaTexto}>
              <h2 className={styles.ctaTitulo}>¿Necesita un repuesto urgente?</h2>
              <p className={styles.ctaDesc}>Contáctenos con el modelo de su equipo y nuestro equipo le proporcionará una cotización y tiempo de entrega el mismo día.</p>
            </div>
            <div className={styles.ctaBtns}>
              <a href="#contact" className="btn btn-primary">Cotizar repuesto</a>
              <Link to="/servicios" className="btn btn-secondary">← Ver todos los servicios</Link>
            </div>
          </div>
        </div>
      </section>

      <ContactSection />

      {/* ── LIGHTBOX ── */}
      {lightboxSrc && (
        <div className={styles.lightboxOverlay} onClick={() => setLightboxSrc(null)}>
          <button
            className={styles.lightboxClose}
            onClick={() => setLightboxSrc(null)}
            aria-label="Cerrar"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
          <img
            src={lightboxSrc}
            alt="Vista ampliada"
            className={styles.lightboxImg}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

    </Layout>
  );
};

export default RepuestosDomus;
